import { COVER_TO_CLASS_TYPE } from 'constants/domain-specific';
import { Cover, DynamicCoverQuestion, DynamicCoverQuestionID } from 'types/cover';

/**
 * @description
 * Returns a boolean stating whether or not a dynamic question exists
 * in the dynamicCoverQuestions result, which is stored from the Ref-Data API call.
 * They are grouped by cover, hence you should provide a cover in association with the questionID
 * to prevent question name collisions across multiple covers.
 * i.e. exampleSI could be common across Liability and Theft
 */
export const dynamicQuestionExists = (
  dynamicCoverQuestions: DynamicCoverQuestion[],
  cover: Cover,
  questionId: DynamicCoverQuestionID
): boolean => {
  const classType = COVER_TO_CLASS_TYPE[cover];
  const dynamicQuestions = dynamicCoverQuestions?.find((cq) => cq.cover === classType);

  if (!dynamicQuestions) return false;

  return dynamicQuestions.options.some((o) => o.questionId === questionId);
};
